import {Router} from "@angular/router";
import {UserLoginDto} from "../../contracts/auth/user-login.dto";
import {Component} from '@angular/core';
import {AuthService} from "../../services/auth/auth.service";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {NavbarComponent} from "../../components/navbar/navbar.component";

@Component({
  selector: 'login',
  standalone: true,
  templateUrl: './login.component.html',
  imports: [FormsModule, TranslateModule, NavbarComponent]
})
export class LoginComponent {
  model: UserLoginDto = new UserLoginDto();
  saving: boolean;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  async login() {
    if (this.saving) return;
    this.saving = true;
    try {
      await this.authService.login(this.model);
      this.router.navigate(['/']);
    } catch (error) {
      console.error(error);
    }
    this.saving = false;
  }
}
